var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_221465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9333 3.16675H15.7333C15.2912 3.16675 14.9333 3.52462 14.9333 3.96675C14.9333 4.40887 15.2912 4.76675 15.7333 4.76675H18.9333C19.3754 4.76675 19.7333 4.40887 19.7333 3.96675C19.7333 3.52462 19.3754 3.16675 18.9333 3.16675Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 0.5H9.59999C7.83574 0.5 6.39999 1.93575 6.39999 3.7V29.3C6.39999 31.0642 7.83574 32.5 9.59999 32.5H22.4C24.1642 32.5 25.6 31.0642 25.6 29.3V3.7C25.6 1.93575 24.1642 0.5 22.4 0.5ZM24 29.3C24 30.1838 23.2837 30.9 22.4 30.9H9.59999C8.71624 30.9 7.99999 30.1838 7.99999 29.3V3.7C7.99999 2.81625 8.71624 2.1 9.59999 2.1H22.4C23.2837 2.1 24 2.81625 24 3.7V29.3Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.8333C16.8836 29.8333 17.6 29.117 17.6 28.2333C17.6 27.3496 16.8836 26.6333 16 26.6333C15.1163 26.6333 14.4 27.3496 14.4 28.2333C14.4 29.117 15.1163 29.8333 16 29.8333Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 4.76675C13.5085 4.76675 13.8667 4.40858 13.8667 3.96675C13.8667 3.52492 13.5085 3.16675 13.0667 3.16675C12.6249 3.16675 12.2667 3.52492 12.2667 3.96675C12.2667 4.40858 12.6249 4.76675 13.0667 4.76675Z",
    fill: "#8694A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_221465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.965ddeba876416319c245fe30c999212.svg";
export { ForwardRef as ReactComponent };